import { render, staticRenderFns } from "./Processes.vue?vue&type=template&id=10948641&"
import script from "./Processes.vue?vue&type=script&lang=js&"
export * from "./Processes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports